import { render, staticRenderFns } from "./CryptoChart.vue?vue&type=template&id=e70bf2c6&"
import script from "./CryptoChart.vue?vue&type=script&lang=js&"
export * from "./CryptoChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports